// Shim de react-dom: repone findDOMNode, eliminado en React 19, para las
// librerías heredadas que todavía lo usan (react-mapbox-gl, entre otras).
// El alias de vite.config.ts mapea el especificador exacto 'react-dom' a este
// archivo; la ruta relativa de abajo no coincide con ese patrón, así que no
// se produce recursión.
import ReactDOM from '../node_modules/react-dom/index.js';

console.log('SALE_SPHERE: react-dom-proxy loaded');

const findDOMNode = (componentOrElement) => {
  if (!componentOrElement) return null;
  if (componentOrElement instanceof HTMLElement) return componentOrElement;
  if (typeof componentOrElement.render === 'function') {
    // This is likely a class component.
    // In React 19, we can't easily get the DOM node without a ref.
    // However, most legacy libs use findDOMNode(this) inside componentDidMount.
    // We'll return null and hope the library handles it or we'll need a more complex shim.
    return null;
  }
  return componentOrElement;
};

// Los nombres se reexportan uno por uno a propósito. react-dom 19 es un paquete
// CommonJS, y `export * from` sobre CJS no expone los nombres de forma estática:
// el optimizador de dependencias de Vite generaba un módulo con solo `default` y
// `findDOMNode`, y cualquier `import { createPortal } from 'react-dom'` fallaba
// con "does not provide an export named 'createPortal'" — aunque en tiempo de
// ejecución existiera y aunque la compilación de producción con Rollup sí
// funcionara. Al agregar un export nuevo aquí hay que regenerar la caché:
// rm -rf node_modules/.vite
export const {
  createPortal,
  flushSync,
  preconnect,
  prefetchDNS,
  preinit,
  preinitModule,
  preload,
  preloadModule,
  requestFormReset,
  unstable_batchedUpdates,
  useFormState,
  useFormStatus,
  version,
  // Lo consume react-dom/client, que no pasa por este alias pero lo espera aquí.
  __DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE
} = ReactDOM;

export { findDOMNode };

export default {
  ...ReactDOM,
  findDOMNode
};
